import React, { CSSProperties } from 'react';
import { Button, ButtonProps } from 'semantic-ui-react';
import useTheme from 'theme/useTheme';
import util from 'utils/utils';

type RoundButtonProps = ButtonProps & {
  primary?: boolean,
  dispatch?: any,
  style?: CSSProperties,
};

const RoundButton = ({
  dispatch: _dispatch, icon, style = {}, primary, ...props
} : RoundButtonProps) => {
  const theme = useTheme();
  return (
    <Button {...props} icon={icon} style={{ ...style, backgroundColor: primary ? theme.primaryColour : theme.secondaryColour, color: util.getTextColour(primary ? theme.primaryColour : theme.secondaryColour) }} />
  );
};

export default RoundButton;
